import { configureStore } from "@reduxjs/toolkit";
import reducer from "store/reducers/rootReducer";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import * as authApi from "api/authApi";
import * as clientApi from "api/clientApi";
import * as messageApi from "api/messageApi";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["layout","chats"],
};

const persistedReducer = persistReducer(persistConfig, reducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
      thunk: {
        extraArgument: {
          /* TODO - add API object here */
          authApi,
          clientApi,
          messageApi,
        },
      },
    }),
  devTools: process.env.NODE_ENV === "development",
  enhancers: [],
});

export const getStoreState = () => {
  return store.getState();
};

export default store;
